import React from 'react';
import { Button } from '@mui/material';

interface IDeleteModalProps {
    handleDeleteModalClose: any;
    handleDelete: any;
}

const DeleteModal: React.FC<IDeleteModalProps> = (props: IDeleteModalProps) => {
  const { handleDeleteModalClose, handleDelete } = props;

  return (
    <div className='new-api-modal-paper'>
      <div className='api-modal-head'>
        <div className='api-icon-div-delete'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6' stroke='#D92D20' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
        <svg onClick={handleDeleteModalClose} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
        </svg>
      </div>
      <div className='api-modal-content'>
        <div className='api-modal-head-words'>
          <div className='api-modal-head-title'>
            <h1>Uh oh! You need an API payment plan</h1>
          </div>
          <h2>To access BITE API, you must set your monthly API meter preferences. </h2>
        </div>
      </div>

      <div className='new-api-modal-btns'>
        <Button
          onClick={handleDeleteModalClose}
          sx={{ color: '#BDBEC1', border: '1px solid #2E3036', textTransform: 'none', width: '50%', padding: '10px 14px', borderRadius: '8px' }}
        >Cancel
        </Button>
        <Button
          onClick={handleDelete}
          sx={{ color: '#EFF1F6', background: '#D92D20', textTransform: 'none', width: '50%', padding: '10px 14px', borderRadius: '8px' }}
        >Delete
        </Button>

      </div>
    </div>
  );
};

export default DeleteModal;
